
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText, FormattedText } = require('core/i18n').i18n;

const DeletePeriodicLoadErrorStep = props => {
    const { immCard } = props;
    const cardAlias = immCard.getIn(['alias','current']);
    const goBackButtonLabel = formatText('cardBlock-backToCard', [cardAlias]).toUpperCase();
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/movements`;
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToDetails
    };

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError errorMessage={formatText('deletePeriodicLoadsError-title')} mainButton={goBackButton}>
                <section className="row">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        <FormattedText value={`deletePeriodicLoadsError-description`} />
                    </div>
                </section>
            </WizardError>
        </div>
    )
};

DeletePeriodicLoadErrorStep.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = DeletePeriodicLoadErrorStep;